// extracted by mini-css-extract-plugin
export default {"content":"PrivacyPolicy_content__hEET0","content__sub_title":"PrivacyPolicy_content__sub_title__5-m1m","content__mb_20":"PrivacyPolicy_content__mb_20__GpCdu"};